module.exports = __webpack_public_path__ + "img/user-1.e88b315f.jpg";